angular.module('Itao.IndicatorMap').directive('colorSetLegend', ['mapConfig', function (mapConfig) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'colorSetLegend.html',
    restrict: 'E',
    replace: true,
    scope: {
      colorSet: '=',
      hideColorset: '='
    },
    link: function (scope) {
      // for print-style to add !importand and prevent converting to rgb()
      scope.ngAttrScaleColor = function(color) {
        return  'background-color: '+color+' !important';
      };
    }
  };
}]);
